
import React from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import App from './App.tsx';
import './index.css';
import './styles/dark-mode-improvements.css';
import './i18n/config';

// تطبيق المظهر المحفوظ عند بدء التطبيق
const initTheme = () => {
  const savedTheme = localStorage.getItem('theme');
  const savedContrast = localStorage.getItem('contrast-mode');
  
  if (savedTheme === 'dark' || 
      (savedTheme === 'system' && window.matchMedia('(prefers-color-scheme: dark)').matches) ||
      (!savedTheme && window.matchMedia('(prefers-color-scheme: dark)').matches)) {
    document.documentElement.classList.add('dark');
  }
  
  if (savedContrast) {
    document.documentElement.setAttribute('data-contrast', savedContrast);
  }
};

initTheme();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes - data stays fresh longer
      gcTime: 10 * 60 * 1000, // 10 minutes - keep in cache longer (renamed from cacheTime)
      refetchOnWindowFocus: false, // Don't refetch on window focus - saves bandwidth
      refetchOnMount: false, // Don't always refetch on mount - use cache
      refetchOnReconnect: true, // Still refetch on reconnect
      retry: 2, // Reduce retry count for faster failure handling
      retryDelay: 1000, // 1 second delay between retries
    },
    mutations: {
      retry: 1, // Keep mutation retry at 1
    },
  },
});

createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>
);
